import { FC } from "react";
import EasyAPTLogo from "../../assets/logos/EasyAptRectangle.png";
import Icon from "../../components/icon/Icon";

interface IBrandProps {
  asideStatus: boolean;
  setAsideStatus(...args: unknown[]): unknown;
}
const Brand: FC<IBrandProps> = ({ asideStatus, setAsideStatus }) => {
  return (
    <div className="brand">
       <div className="brand-logo">
        <h1 className="brand-title ">
            <img
              src={EasyAPTLogo}
              alt="EasyAPT"
              height={100}
              onClick={() => setAsideStatus(!asideStatus)}
              style={{ paddingTop: "5px" }}
            />
        </h1>
      </div> 
      <button
        type="button"
        className="btn brand-aside-toggle"
        aria-label="Toggle Aside"
        onClick={() => setAsideStatus(!asideStatus)}
      >
        <Icon icon={asideStatus ? "LastPage" : "FirstPage"} className="brand-aside-toggle-icon" />
      </button>
     
    </div>
  );
};

export default Brand;
